import { render, staticRenderFns } from "./SpiderScrapy.vue?vue&type=template&id=acf68bd8&scoped=true&"
import script from "./SpiderScrapy.vue?vue&type=script&lang=js&"
export * from "./SpiderScrapy.vue?vue&type=script&lang=js&"
import style0 from "./SpiderScrapy.vue?vue&type=style&index=0&id=acf68bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf68bd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acf68bd8')) {
      api.createRecord('acf68bd8', component.options)
    } else {
      api.reload('acf68bd8', component.options)
    }
    module.hot.accept("./SpiderScrapy.vue?vue&type=template&id=acf68bd8&scoped=true&", function () {
      api.rerender('acf68bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Scrapy/SpiderScrapy.vue"
export default component.exports